import { Injectable } from '@angular/core';
import { BaseService } from '../../base.service';
import { environment } from '../../../environments/environment';
import { InvoiceLine } from '../../models/invoice-line';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()

/**
 * InvoiceLinesService contains logic for making api calls for invoice lines
 */
export class InvoiceLinesService extends BaseService
{
	private api: string;

	/**
	 * InvoiceLinesService constructor
	 *
	 * @param {HttpService} http
	 */
	constructor(private http: HttpClient)
	{
		super();
		this.api = environment.api_url;
	}

	/**
	 * Makes a get request to retrieve an InvoiceLine by id
	 *
	 * @param {number} id
	 *
	 * @returns {Observable<InvoiceLine>}
	 */
	getInvoiceLine(id: number): Observable<InvoiceLine>
	{
		return this.http.get(this.api + 'invoice-lines/' + id)
			.map(response => response['data'] as InvoiceLine);
	}

	/**
	 * Makes a post request to store a new InvoiceLine
	 *
	 * @param {InvoiceLine} invoiceLine
	 *
	 * @returns {Observable<InvoiceLine>}
	 */
	storeInvoiceLine(invoiceLine: InvoiceLine): Observable<InvoiceLine>
	{
		return this.http.post(this.api + 'invoice-lines', invoiceLine)
			.map(response => response['data'] as InvoiceLine);
	}

	/**
	 * Makes a put request to update an existing InvoiceLine
	 *
	 * @param {number} id
	 * @param {InvoiceLine} invoiceLine
	 *
	 * @returns {Observable<InvoiceLine>}
	 */
	updateInvoiceLine(id: number, invoiceLine: InvoiceLine): Observable<InvoiceLine>
	{
		return this.http.put(this.api + 'invoice-lines/' + id, invoiceLine)
			.map(response => response['data'] as InvoiceLine);
	}

	/**
	 * Makes a delete request to delete an existing InvoiceLine
	 *
	 * @param {number} id
	 *
	 * @returns {Observable<Response>}
	 */
	deleteInvoiceLine(id: number): Observable<Response>
	{
		return this.http.delete(this.api + 'invoice-lines/' + id)
			.map(response => response['data'] as Response);
	}
}



// WEBPACK FOOTER //
// ./src/app/invoices/services/invoice-lines.service.ts